module.exports = __webpack_public_path__ + "static/media/shell.2a01789d.webp";